import React from 'react';
import { useCountdown } from '../utils/useCountdown';
type CountdownProps = {
  variant?: 'block' | 'inline';
};
export function CountdownTimer({
  variant = 'block'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hrs'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className={`flex items-stretch justify-center gap-2 ${variant === 'inline' ? '' : 'mt-2'}`} role="timer" aria-label="Offer countdown" data-id="element-50" data-mp="3c25rd9zgs002">
      {units.map(unit => <div key={unit.label} className="min-w-[64px] rounded-xl bg-charcoal px-3 py-2 text-center sm:min-w-[84px]" data-id="element-51" data-mp="323yb6td01lz4">
          <span className="block font-head text-xl font-extrabold tabular-nums text-white sm:text-3xl" data-id="element-52" data-mp="373ba4ch5aji2">
            {unit.value}
          </span>
          <span className="block font-head text-[9px] font-semibold uppercase tracking-widest text-white/60 sm:text-[11px]" data-id="element-53" data-mp="15bg52fpe9d8t">
            {unit.label}
          </span>
        </div>)}
    </div>;
}
export function OfferBar() {
  return <section aria-label="Limited-time offer" className="w-full bg-white px-4 py-8 sm:px-6" data-id="element-54" data-mp="t1afr7hmy89k">
      <div className="mx-auto max-w-3xl rounded-2xl border border-urgent/30 bg-urgent/5 p-5 text-center" data-id="element-55" data-mp="17py8z740e5wc">
        <span className="inline-block rounded-full bg-urgent px-3 py-1 font-head text-[10px] font-bold uppercase tracking-wider text-white sm:text-xs" data-id="element-56" data-mp="12t7rqgggx49c">
          Limited-Time Offer
        </span>
        <p className="mt-2 font-head text-sm font-bold uppercase tracking-wide text-charcoal sm:text-base" data-id="element-57" data-mp="a4j0ra94mfbb">
          Launch price ends in:
        </p>
        <CountdownTimer data-id="element-58" data-mp="k1f28w0ly16d" />
        <p className="mt-3 text-xs leading-snug text-softgray sm:text-sm" data-id="element-59" data-mp="k15kfvppv0br">
          After that, the price increases and the strategic bonuses may no longer be included.
        </p>

        <div className="mx-auto mt-4 max-w-md" data-id="element-60" data-mp="1vgu68jr8htaz">
          <div className="flex items-center justify-between font-head text-[10px] font-bold uppercase tracking-wider text-charcoal sm:text-xs" data-id="element-61" data-mp="1vg0vl7p5mjnk">
            <span data-id="element-62" data-mp="x4hk9oz4wqow">Limited Availability</span>
            <span className="text-urgent" data-id="element-63" data-mp="x3gcbtdf0kbe">72% Claimed</span>
          </div>
          <div className="mt-1.5 h-2.5 w-full overflow-hidden rounded-full bg-charcoal/10" role="progressbar" aria-valuenow={72} aria-valuemin={0} aria-valuemax={100} aria-label="Availability claimed" data-id="element-64" data-mp="123kt7ki8jh25">
            <div className="h-full rounded-full bg-urgent" style={{
            width: '72%'
          }} data-id="element-65" data-mp="edqfl0q3dogu" />
          </div>
        </div>
      </div>
    </section>;
}